import { Component, Input, OnInit } from '@angular/core';
import { Order, OrderType } from 'src/app/api/contracts/order';

@Component({
  selector: 'app-order-list-item-header',
  templateUrl: './order-list-item-header.component.html',
  styleUrls: ['./order-list-item-header.component.scss'],
})
export class OrderListItemHeaderComponent  implements OnInit {

  @Input() order!: Order;

  public readonly orderTypes = OrderType;

  constructor() { }

  ngOnInit() {
    return;
  }

}
